var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJarinline = function SvgJarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 355 84.534"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jar_inline_svg__a",
    x1: 14.033,
    x2: 14.033,
    y1: 0,
    y2: 28.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a841ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36a2ff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 189279"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#707070",
    "data-name": "Rectangle 26585",
    opacity: 0,
    style: {
      display: "inline",
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#241553",
      fillOpacity: 1,
      stroke: "#241553",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h142.99v72H0z",
    style: {
      opacity: 1,
      fill: "#241553",
      fillOpacity: 1,
      stroke: "#241553",
      strokeOpacity: 1
    },
    transform: "matrix(.98096 0 0 .97069 3.356 4.881)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M57.414 10.558h141.99v71H57.414z",
    style: {
      opacity: 1,
      fill: "#241553",
      fillOpacity: 1,
      stroke: "#241553",
      strokeOpacity: 1
    },
    transform: "matrix(.98096 0 0 .97069 3.356 4.881)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2.921-4.529h202.325v86.086H-2.921z",
    style: {
      opacity: 1,
      fill: "#241553",
      fillOpacity: 1,
      stroke: "#241553",
      strokeOpacity: 1
    },
    transform: "matrix(.98096 0 0 .97069 3.356 4.881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.659 41.186h9.019v.314h-9.019z",
    style: {
      fill: "#241553",
      fillOpacity: 1,
      stroke: "#241553",
      strokeWidth: 1.02479,
      strokeOpacity: 1
    },
    transform: "matrix(.98096 0 0 .97069 3.356 4.881)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "60b39746be1c3f7bfb3b03f2_group_9270"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.365 25.151v24.243a10.455 10.346 0 0 1-2.949 7.835 10.946 10.83 0 0 1-7.9 2.794 11.281 11.163 0 0 1-8.075-2.868 10.594 10.483 0 0 1-3.076-8.015h7.001a5.58 5.521 0 0 0 1.075 3.462 3.63 3.592 0 0 0 2.972 1.239 3.563 3.526 0 0 0 2.9-1.187 5.003 4.95 0 0 0 1-3.266V25.151Zm6.35 20.732a16.033 15.865 0 0 1 1.674-7.372 12.272 12.143 0 0 1 4.553-4.95 12.113 11.986 0 0 1 6.425-1.732 11.281 11.163 0 0 1 5.426 1.237 11.01 10.894 0 0 1 3.728 3.116v-3.917h7.05V59.68h-7.054v-4.007a10.413 10.304 0 0 1-3.728 3.19 11.397 11.277 0 0 1-5.475 1.262 11.772 11.648 0 0 1-6.376-1.78 12.598 12.467 0 0 1-4.553-5.021 16.298 16.127 0 0 1-1.674-7.447zm21.8.097a8.978 8.884 0 0 0-1-4.327 7.05 6.976 0 0 0-2.689-2.78 7.217 7.141 0 0 0-3.65-.966 7.09 7.015 0 0 0-3.6.94 7.153 7.078 0 0 0-2.676 2.743 8.693 8.602 0 0 0-1.025 4.28 8.98 8.886 0 0 0 1.022 4.325 7.38 7.303 0 0 0 2.7 2.848 6.858 6.786 0 0 0 3.574.99 7.217 7.141 0 0 0 3.655-.966 7.05 6.976 0 0 0 2.695-2.775 8.978 8.884 0 0 0 .996-4.322zm20.899-9.45a9.841 9.738 0 0 1 3.526-3.413 9.804 9.701 0 0 1 4.976-1.238v7.273h-1.851a7.09 7.016 0 0 0-4.976 1.533 7.145 7.07 0 0 0-1.675 5.339v13.66h-6.998V32.268h7.001z",
    "data-name": "Path 39662"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 134472"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#jar_inline_svg__a)",
    d: "M14.033 0A14.033 14.033 0 1 1 0 14.033 14.033 14.033 0 0 1 14.033 0",
    "data-name": "Path 39663",
    style: {
      fill: "url(#jar_inline_svg__a)"
    },
    transform: "matrix(.98096 0 0 .97069 36.726 29.42)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.494 34.182c-.27-7.787-5.147-12.868-13.064-13.59-6.064-.554-10.453 2.111-12.036 7.317a15.436 15.275 0 0 0-.611 3.68c-.121 2.473-.236 6.407-.295 9.276-.478-.32-.869-.583-1.237-.86a2.727 2.699 0 0 0-4.087-.015 2.772 2.743 0 0 0 .468 4.13 451.906 451.906 0 0 0 5.606 5.03c1.864 1.65 3.218.997 3.857.451 2.61-2.207 4.815-4.224 6.745-6.169a3.204 3.17 0 0 0 .142-3.162 2.319 2.295 0 0 0-1.447-1.165 2.654 2.627 0 0 0-2.118.399l-.042.028-2.11 1.545-.016-.52a74.445 73.665 0 0 1 .078-8.833c.068-.666.166-1.344.294-2.01a4.932 4.88 0 0 1 .33-1.067 4.044 4.001 0 0 1 3.55-2.359 14.518 14.366 0 0 1 4.414.239 6.945 6.872 0 0 1 6.033 6.58c.253 7.95.251 15.023 0 21.626a6.743 6.673 0 0 1-2.028 4.903 6.499 6.43 0 0 1-4.953 1.82c-6.68.199-13.701.199-20.866.012a6.492 6.424 0 0 1-4.967-1.776 6.736 6.666 0 0 1-2.066-4.882 272.449 272.449 0 0 1 0-21.931c.146-3.764 2.657-6.16 6.888-6.58.333-.031.667-.045 1.022-.06a14.512 14.36 0 0 0 1.504-.113c.098-.014.197-.03.29-.05a.785.777 0 0 0 .223-.04l.133-.045a3.555 3.518 0 0 0 .735-.291 8.258 8.171 0 0 0 3.895-3.575 8.937 8.843 0 0 0-1.17-9.715.785.777 0 0 0-1.11-.108l-4.008 3.332a.816.808 0 0 0-.125 1.093 2.788 2.759 0 0 1 .49 2.33 2.401 2.376 0 0 1-1.905 1.473q-.313.02-.62.051a.883.874 0 0 0-.098.012A12.686 12.553 0 0 0 27.629 32.79c-.347 7.03-.347 14.451 0 22.063a12.17 12.043 0 0 0 3.407 8.562 11.741 11.618 0 0 0 8.449 3.555c3.749.2 7.455.301 11.084.301 3.694 0 7.324-.104 10.845-.308 7.351-.431 11.745-5.028 12.054-12.614.237-6.715.257-13.502.026-20.168z",
    "data-name": "Path 39664"
  }))))));
};
export default SvgJarinline;